import $ from 'jquery';
import { ENDERECO_API } from '../../config/constant';
import { decode as rawBase64Decode, encode as base64_encode } from 'base-64';
import Swal from 'sweetalert2';
import { showDuplicateLoginAlert } from '../../components/Auth/DuplicateLoginAlert';

const normalizeInitDadosResponse = (value) => {
  if (typeof value !== 'string') {
    return value;
  }

  let normalizedValue = value.trim();

  if (normalizedValue.startsWith('"') && normalizedValue.endsWith('"')) {
    normalizedValue = JSON.parse(normalizedValue);
  }

  return normalizedValue;
};

const base64_decode = (value) => rawBase64Decode(normalizeInitDadosResponse(value));

const isInitDadosAuthError = (xhr) => {
  const candidates = [xhr?.message, xhr?.responseText, xhr?.responseJSON];

  return candidates.some((value) => {
    if (value === 'erro_auth') {
      return true;
    }

    if (typeof value !== 'string') {
      return false;
    }

    let normalizedValue = value.trim();

    if (normalizedValue.startsWith('"') && normalizedValue.endsWith('"')) {
      normalizedValue = JSON.parse(normalizedValue);
    }

    try {
      normalizedValue = base64_decode(normalizedValue);
    } catch (err) {
      return normalizedValue === 'erro_auth';
    }

    return normalizedValue === 'erro_auth';
  });
};

const handleInitDadosError = (xhr, reject, rejectMessage) => {
  if (isInitDadosAuthError(xhr)) {
    showDuplicateLoginAlert();
  }

  reject([400, { message: rejectMessage }]);
};

const getSession = () => {
  const usersRt = sessionStorage.getItem('ddesp');
  return usersRt !== null ? JSON.parse(base64_decode(usersRt)) : null;
};

const getAuthHeaders = (token) => ({
  Authorization: `Bearer ${token}`,
});

const trataLoginSuccess = (data) => {
  data = data[0];

  if (data !== -1) {
    const empReg = data[0];
    const uReg = data[3];
    const u64 = base64_encode(uReg);
    const dashboard = data[15];
    const access = {
      possuiEmpresas: data[11][0].possuiEmpresas,
      primeiroAcesso: data[11][0].primeiroAcesso,
      possuiNotas: data[11][0].possuiNotas,
      possuiCert: data[11][0].possuiCert,
    };
    const storage = base64_encode(JSON.stringify(data));

    sessionStorage.clear();
    localStorage.setItem(`dashConfig${u64}`, dashboard);
    sessionStorage.setItem('ddesp', storage);
    localStorage.setItem(`ddespU${u64}`, base64_encode(JSON.stringify([base64_encode(empReg), base64_encode(uReg)])));
    localStorage.setItem(`xpaccss${u64}`, base64_encode(JSON.stringify(access)));
  }
};

const showSessionDuplicatedCountdown = () => {
  let timerInterval;

  return Swal.fire({
    title: 'Sessão Duplicada!',
    html: 'Foi iniciada uma nova sessão com seu usuário.<br/> Esta sessão será encerrada!<br/><b></b>',
    icon: 'warning',
    confirmButtonText: 'Ok',
    allowOutsideClick: false,
    allowEscapeKey: false,
    allowEnterKey: false,
    showConfirmButton: false,
    timerProgressBar: true,
    timer: 5000,
    didOpen: () => {
      Swal.showLoading();
      const timer = Swal.getPopup().querySelector('b');
      timerInterval = setInterval(() => {
        const value = Swal.getTimerLeft() / 1000;
        timer.textContent = `${value.toFixed(0)}`;
      }, 100);
    },
    willClose: () => {
      clearInterval(timerInterval);
    },
  }).then(() => {
    window.location.href = '/login';
    sessionStorage.clear();
  });
};

const ajaxInitEspiaoEvent = ({
  type,
  ll,
  dd,
  tk,
  parseType = 'raw',
  rejectMessage = 'erro',
  extraData = {},
  onSuccess,
}) => new Promise(function (resolve, reject) {
  try {
    $.ajax({
      url: encodeURI(`${ENDERECO_API}src/api/controller/espiaoCtrl.class.php`),
      type,
      dataType: 'text',
      headers: getAuthHeaders(tk),
      data: {
        pp: base64_encode('init'),
        ll: base64_encode(ll),
        dd: base64_encode(JSON.stringify(dd)),
        tk,
        ...extraData,
      },
      success: function (data, status, xhr) {
        const _auth = typeof data === 'string' ? data.trim().replace(/^"|"$/g, '') : '';
        if (_auth === 'erro_auth' || _auth === 'sessao_expirada') {
          sessionStorage.clear();
          window.location.href = '/auth/login';
          return;
        }

        if (onSuccess) {
          onSuccess({ data, status, xhr, resolve, reject });
          return;
        }

        if (parseType === 'jsonBase64') {
          resolve([200, JSON.parse(base64_decode(data))]);
          return;
        }

        if (parseType === 'base64') {
          resolve([200, base64_decode(data)]);
          return;
        }

        resolve([200, data]);
      },
      error: function (xhr) {
        handleInitDadosError(xhr, reject, rejectMessage);
      },
    });
  } catch (err) {
    reject([500, { message: err + ' Server Error' }]);
  }
});

const ajaxInitControllerEvent = ({
  type,
  ll,
  dd,
  tk,
  parseType = 'raw',
  rejectMessage = 'erro',
}) => new Promise(function (resolve, reject) {
  try {
    $.ajax({
      url: encodeURI(`${ENDERECO_API}src/api/controller/initDados_controller.class.php`),
      type,
      dataType: 'text',
      headers: getAuthHeaders(tk),
      data: {
        pp: base64_encode('init'),
        ll: base64_encode(ll),
        dd,
      },
      success: function (data) {
        if (parseType === 'base64') {
          resolve([200, base64_decode(data)]);
          return;
        }

        resolve([200, data]);
      },
      error: function (xhr) {
        handleInitDadosError(xhr, reject, rejectMessage);
      },
    });
  } catch (err) {
    reject([500, { message: 'Server Error' }]);
  }
});

const RestDataInitPost = (config) => {
  const Arr_ = JSON.parse(config.data);
  const caminho = Arr_.dest.trim();
  const storage = getSession();
  const emp = storage[0];
  const uid = storage[3];
  const token = storage[14];

  switch (caminho) {
    case 'dataIni': {
      const moduloAtual = localStorage.getItem('moduloAtual');
      const dataPost = [base64_encode(emp), base64_encode(uid), base64_encode(moduloAtual)];

      return ajaxInitEspiaoEvent({
        type: 'Get',
        ll: 'dataIni',
        dd: dataPost,
        tk: token,
        onSuccess: ({ data, resolve }) => {
          const parsedData = JSON.parse(base64_decode(data));

          if (parsedData[0] === 'logout') {
            showSessionDuplicatedCountdown();
            return;
          }

          resolve([200, parsedData]);
        },
      });
    }
    case 'deletarCPU': {
      const dataPost = [base64_encode(emp), base64_encode(uid), base64_encode(Arr_.dataPost)];

      return ajaxInitControllerEvent({
        type: 'Get',
        ll: 'deletarCPU',
        dd: base64_encode(dataPost),
        tk: token,
        parseType: 'base64',
      });
    }
    case 'recarregaSession': {
      const dataPost = [base64_encode(emp), base64_encode(uid)];

      return ajaxInitEspiaoEvent({
        type: 'Post',
        ll: 'recarregaSession',
        dd: dataPost,
        tk: token,
        extraData: { data: Arr_.data },
        onSuccess: ({ data, resolve }) => {
          const parsedData = JSON.parse(base64_decode(data));
          trataLoginSuccess(parsedData);
          resolve([200, 'ok']);
        },
      });
    }
    case 'salvarUsuarioSenhaMunicipio': {
      const dataPost = [base64_encode(emp), base64_encode(uid), base64_encode(Arr_.dataPost)];

      return ajaxInitEspiaoEvent({
        type: 'Post',
        ll: 'salvarUsuarioSenhaMunicipio',
        dd: dataPost,
        tk: token,
        extraData: { data: Arr_.dataPost },
        parseType: 'base64',
      });
    }
    default:
      return new Promise((resolve, reject) => reject([404, { message: 'Rota não encontrada' }]));
  }
};

const RestDataInitGet = (config) => {
  const caminho = config.dest.trim();
  const storage = getSession();
  const emp = storage[0];
  const uid = storage[3];
  const token = storage[14];
  const fullDataPost = [base64_encode(emp), base64_encode(uid), base64_encode(JSON.stringify(config.dataPost))];
  const baseDataPost = [base64_encode(emp), base64_encode(uid)];

  switch (caminho) {
    case 'logEmp':
      return ajaxInitEspiaoEvent({
        type: 'Get',
        ll: 'newGetLog',
        dd: fullDataPost,
        tk: token,
        parseType: 'jsonBase64',
      });
    case 'logMonitor':
      return ajaxInitEspiaoEvent({
        type: 'Get',
        ll: 'logMonitor',
        dd: baseDataPost,
        tk: token,
        parseType: 'jsonBase64',
      });
    case 'checkUserTokenAcesso':
      return ajaxInitEspiaoEvent({
        type: 'Get',
        ll: 'checkUserTokenAcesso',
        dd: baseDataPost,
        tk: token,
        onSuccess: ({ data, resolve }) => {
          resolve([200, { message: base64_decode(data) }]);
        },
      });
    case 'downPDF':
      return new Promise(function (resolve, reject) {
        try {
          $.ajax({
            url: encodeURI(`${ENDERECO_API}src/api/controller/espiaoCtrl.class.php`),
            type: 'Get',
            dataType: 'application/pdf',
            headers: getAuthHeaders(token),
            data: {
              pp: base64_encode('init'),
              ll: base64_encode('downloadPdf'),
              dd: base64_encode(JSON.stringify(fullDataPost)),
              tk: token,
            },
            success: function (data) {
              resolve([200, { message: base64_decode(data) }]);
            },
            error: function (xhr) {
              if (isInitDadosAuthError(xhr)) {
                showDuplicateLoginAlert();
                return;
              }

              const response = base64_decode(xhr.responseText);
              const blob = new Blob([response], { type: 'application/pdf;charset=utf-8' });
              const url = window.URL.createObjectURL(new Blob([blob]));
              const link = document.createElement('a');
              link.href = url;
              link.setAttribute('download', 'document.pdf');
              document.body.appendChild(link);
              link.click();
              resolve([200, { message: xhr.responseText }]);
            },
          });
        } catch (err) {
          reject([500, { message: err }]);
        }
      });
    case 'getLimiteEmpresasDisponivel':
      return ajaxInitEspiaoEvent({
        type: 'Get',
        ll: 'getLimiteEmpresasDisponivel',
        dd: baseDataPost,
        tk: token,
        parseType: 'jsonBase64',
      });
    case 'getMunicipios':
      return ajaxInitEspiaoEvent({
        type: 'Get',
        ll: 'getMunicipios',
        dd: fullDataPost,
        tk: token,
        parseType: 'jsonBase64',
      });
    case 'getSaldoCte':
      return ajaxInitEspiaoEvent({
        type: 'Get',
        ll: 'getSaldoCte',
        dd: fullDataPost,
        tk: token,
        parseType: 'jsonBase64',
      });
    case 'getSaldoCteResumo':
      return ajaxInitEspiaoEvent({
        type: 'Get',
        ll: 'getSaldoCteResumo',
        dd: fullDataPost,
        tk: token,
        parseType: 'jsonBase64',
      });
    case 'getUsuarioSenhaMunicipio':
      return ajaxInitEspiaoEvent({
        type: 'Get',
        ll: 'getUsuarioSenhaMunicipio',
        dd: fullDataPost,
        tk: token,
        parseType: 'jsonBase64',
      });
    case 'notificacoes':
      return ajaxInitEspiaoEvent({
        type: 'Get',
        ll: 'notificacoes',
        dd: fullDataPost,
        tk: token,
        parseType: 'jsonBase64',
      });
    case 'logs':
      return ajaxInitEspiaoEvent({
        type: 'Get',
        ll: 'newGetLog',
        dd: fullDataPost,
        tk: token,
        parseType: 'jsonBase64',
      });
    default:
      return new Promise((resolve, reject) => reject([404, { message: 'Rota não encontrada' }]));
  }
};

export { RestDataInitPost, RestDataInitGet };